import { useQuery } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { getDocumentV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDocumentListQuery = (tag?: string) => {
	return useQuery({
		queryKey: DocumentKeys.list(tag),
		queryFn: processResponse(() => getDocumentV2(tag)),
	});
};
